export class Attachment {

    public name: string;
    public contentType: string;
    public data: any;
}